import { STANDARDS_SEARCH_TAB, COLLECTIONS_SEARCH_TAB } from "@/components/Search/constants";
import { capitalizeFirst } from "@/utils/strHelpers";
export const gaTrackSearchProductLinkClick = (activeSearchTab: string, 
    params: any, 
    resultData: any,
    docItem: any  = null ,
    docPosition: number | null = null) => {
        gaTrackSearchEvent(activeSearchTab, `${activeSearchTab}SearchResultDocClick`, `${activeSearchTab} Result Doc Click`, params, resultData, docItem, docPosition);
    }

export const gaTrackUserSearch = (activeSearchTab: string, 
    params: any, 
    resultData: any) => {
        gaTrackSearchEvent(activeSearchTab, `${activeSearchTab}SearchResult`, `${activeSearchTab} Search Result`, params, resultData);
    }

export const gaTrackSearchEvent = (activeSearchTab: string, 
    eventAction: string,
    eventLabel: string,
    params: any, 
    resultData: any,
    docItem: any  = null ,
    docPosition: number | null = null) => {
      
    const eventParams = { 
        'event' : 'SearchEvent', 
        'eventCategory': 'Search', 
        'eventAction': capitalizeFirst(eventAction), 
        'eventLabel': capitalizeFirst(eventLabel), 
        'searchTerm': params?.['query_1'] ?? '',
        'docNo': docItem?.['name'] ?? '', 
        'docTitle': docItem?.['title'] ?? '', 
        'resultCount': resultData?.['total'] ?? 0, 
        'pageNo': params?.['page'] ?? '',
        'position':docPosition ?? '',
        'docId': docItem?.['doc_id'] ?? '',
        'filterSearchIn':'',
        'filterPublisher': params?.['filter-publisher'] ?? '',
        'filterStatus': params?.['filter-include'] ?? '',
        'filterCategory': params?.['icsCode'] ?? '',
        'filterCrossReference': '',
        'filterMyCollections': '',
        'filterDocumentType': '',
    };
    if(activeSearchTab == STANDARDS_SEARCH_TAB) {
        if ((params['icsCode'] || '').trim() === '') {
            if ((params['icsCodeLevel3'] || '').trim() !== '') {
                params['icsCode'] = params['icsCodeLevel3']
            } else if ((params['icsCodeLevel2'] || '').trim() !== '') {
                params['icsCode'] = params['icsCodeLevel2']
            } else if ((params['icsCodeLevel1'] || '').trim() !== '') {
                params['icsCode'] = params['icsCodeLevel1']
            }
        }
        eventParams['filterSearchIn'] = params?.['filterby'] ?? '';
        eventParams['filterCrossReference'] = params?.['filter-xref'] ?? '';
    }
    if(activeSearchTab == COLLECTIONS_SEARCH_TAB) {
        if ((params['filter-icsCode'] || '').trim() === '') {
            if ((params['filter-icsCodeLevel3'] || '').trim() !== '') {
                params['filter-icsCode'] = params['filter-icsCodeLevel3']
            } else if ((params['filter-icsCodeLevel2'] || '').trim() !== '') {
                params['filter-icsCode'] = params['filter-icsCodeLevel2']
            } else if ((params['filter-icsCodeLevel1'] || '').trim() !== '') {
                params['filter-icsCode'] = params['filter-icsCodeLevel1']
            }
        }
        eventParams['searchTerm'] = params?.['name'] ?? '';
        eventParams['filterPublisher'] = params?.['filter-dcoll'] ?? '';
        eventParams['filterStatus'] = params?.['filter-include'] ?? '';
        eventParams['filterCategory'] = params?.['filter-icsCode'] ?? '';
        eventParams['filterMyCollections'] = params?.['filter-colls'] ?? '';
        eventParams['filterDocumentType'] = params?.['filter-type'] ?? '';
    }
    //@ts-ignore
    window.dataLayer = window.dataLayer || [];
    //@ts-ignore
    window.dataLayer.push(eventParams);
}